import { registerActions, rootActions } from "~/actions/registry";
import type { Action } from "~/actions/types";
import { aiActionsList } from "./ai";
import { documentActions, documentRowActions } from "./documents";
import { navigationActions, settingsJumpActions } from "./navigation";
import { projectActions } from "./projects";
import { settingsActions } from "./settings";
import { themeActions, themeLeafActions } from "./theme";

/**
 * The command bar's top level, in display order. Document row actions are included because
 * a scene can put a document "in context" (DocumentScene does), at which point Rename,
 * Share and Delete become legitimate command-bar entries — the same declarations the
 * right-click menu uses.
 */
export function registerAllActions(): readonly Action[] {
  registerActions(
    ...navigationActions,
    ...aiActionsList,
    ...documentActions,
    ...documentRowActions.filter((action) => !action.id.startsWith("separator")),
    ...projectActions,
    ...themeActions,
    ...settingsActions,
    ...settingsJumpActions,
  );
  return rootActions;
}

/** Bindings live on the actions themselves; this is every action a key can reach. */
export function shortcutActions(): Action[] {
  return [...rootActions, ...themeLeafActions];
}

export * from "./ai";
export * from "./documents";
export * from "./navigation";
export * from "./projects";
export * from "./settings";
export * from "./theme";
